import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getDashboardDaftar = createAsyncThunk("dashboard/daftar", async(periode) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const q = periode ? `?periode=${encodeURIComponent(periode)}` : '';
    const response = await jwtAuthAxios.get(`v1/dashboard/jalur${q}`);
    return response.data;
});

export const getPendaftarPerPeriode = createAsyncThunk("dashboard/daftarPerPeriode", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/dashboard/jalur/per-periode`);
    return response.data;
});

const initialState = {
    loadingDashDaftar : false,
    responseDashDaftar : {},
    loadingPendaftarPerPeriode : false,
    responsePendaftarPerPeriode : { labels: [], data: [] },
}

const dashDaftarSlice = createSlice({
    name:"dashDaftarSlice",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardDaftar.pending, (state) => {
                state.loadingDashDaftar = true;
            })
            .addCase(getDashboardDaftar.fulfilled, (state, action) => {
                state.responseDashDaftar = action.payload;
                state.loadingDashDaftar = false;
            })
            .addCase(getDashboardDaftar.rejected, (state) => {
                state.loadingDashDaftar = false;
            })
            .addCase(getPendaftarPerPeriode.pending, (state) => {
                state.loadingPendaftarPerPeriode = true;
            })
            .addCase(getPendaftarPerPeriode.fulfilled, (state, action) => {
                state.responsePendaftarPerPeriode = action.payload;
                state.loadingPendaftarPerPeriode = false;
            })
            .addCase(getPendaftarPerPeriode.rejected, (state) => {
                state.loadingPendaftarPerPeriode = false;
            });
    }
})

export const dashDaftarSelector = (state) => state.dashDaftar;
export default dashDaftarSlice.reducer;
